<template>
  <div class="wrapper">
    <PageTitle :value="$t('nav.USER_COMPANY')" />
    <Search :label="$t('lookupPlaceholder.COMPANY')" />
    <v-app>
      <FilterList />
      <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="dataList"
        :options.sync="sortOptions"
        :hide-default-footer="true"
        :server-items-length="dataList.length"
        @click:row="handleClickRow"
      >
        <template #[`item.is_active`]="{ item }">
          <TableIcon :value="item.is_active" />
        </template>
        <template #[`item.company_approved`]="{ item }">
          <TableIcon :value="item.company_approved" />
        </template>
      </v-data-table>
      <Pagination />
      <Excel @click="fetchExcelFile" />
    </v-app>
  </div>
</template>

<script>
import table from "@/mixins/table"
import excel from "@/mixins/excel"
import param from "@/mixins/param"
import sort from "@/mixins/sort"
import TableIcon from "@/components/lookup/TableIcon"
import { MENU, CATEGORY, } from "@/constants/mapVarNames"
import { getExcelDataByUsersCategory, } from "@/api/exportExcel"

export default {
  components: {
    TableIcon,
  },
  mixins: [table, excel, sort, param],
  data() {
    return {
      filterItems: {
        gender: null,
        is_active: null,
      },
      headers: [
        {
          text: this.$t("headers.ID"),
          value: "id",
          sortable: true,
        },
        {
          text: this.$t("headers.USERNAME"),
          value: "username",
          sortable: true,
        },
        {
          text: this.$t("headers.NAME"),
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("headers.TEL"),
          value: "tel",
          sortable: false,
        },
        {
          text: this.$t("headers.COMPANY_NAME"),
          value: "company_name",
          sortable: false,
        },
        {
          text: this.$t("headers.COMPANY_SIZE"),
          value: "company_size",
          sortable: false,
        },
        {
          text: this.$t("headers.COMPANY_APPROVED"),
          value: "company_approved",
          sortable: false,
        },
        {
          text: this.$t("headers.IS_ACTIVE"),
          value: "is_active",
          sortable: false,
        },
        {
          text: this.$t("headers.DATE_JOINED"),
          value: "date_joined",
          sortable: false,
        }
      ],
      sortOptions: {},
    }
  },
  watch: {
    sortOptions: {
      handler(value) {
        if (value.sortBy[0]) {
          this.$_sort_handleSort(value.sortBy[0])
        }
      },
      deep: true,
    },
  },
  created() {
    this.$store.commit("SET_LOOKUP_CATEGORY", { menu: MENU.users, category: CATEGORY.company, })
    this.$store.dispatch("setFilterItems", this.filterItems)
    this.$store.dispatch("fetchLookupData")
  },
  methods: {
    async fetchExcelFile() {
      try {
        const params = this.$_param_createParams()
        const response = await getExcelDataByUsersCategory({ category: CATEGORY.company, params, })

        this.$_excel_downloadFile(response, CATEGORY.company)
      } catch (error) {
        this.$store.dispatch("setError", error)
      }
    },
    handleClickRow(rowData) {
      const dataId = rowData.id

      this.$router.push({ name: "companyDetail", params: { id: dataId, }, })
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
